import React from 'react';

import { Text } from '@reckon-web/text';

// ActivityCategory SignOffApprove = 10
export const ActivityCategorySignOffApprove = () => (
  <Text size="small">Signed off the job</Text>
);
